import { defineStore } from 'pinia'
import { ref } from 'vue'

import i18n from '@/libs/i18n'
import type { IUser } from '@/types/User'

export const useAppStore = defineStore('app', () => {
    const JWT          = ref(localStorage.getItem('JWT') || '')
    const loaderActive = ref(0)
    const userData     = ref<IUser>()
    const windowWidth  = ref(window.innerWidth)

    const getJWT      = () => JWT.value
    const isLoggedIn  = () => !!JWT.value
    const isLoaderActive = () => loaderActive.value > 0
    const isMobile    = () => windowWidth.value < 1024

    const setJWTCookie = (jwt: string) => {
        if (jwt) {
            document.cookie = `JWT=${jwt}; path=/; SameSite=Lax`
        } else {
            document.cookie = 'JWT=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax'
        }
    }

    setJWTCookie(JWT.value)

    const setLogin = (jwt: string) => {
        localStorage.setItem('JWT', jwt)
        JWT.value = jwt
        setJWTCookie(jwt)
    }

    const setLogout = () => {
        localStorage.removeItem('JWT')
        JWT.value = ''
        setJWTCookie('')
    }

    const startLoading = () => loaderActive.value++
    const stopLoading  = () => { loaderActive.value = Math.max(0, loaderActive.value - 1) }

    window.addEventListener('resize', () => { windowWidth.value = window.innerWidth })

    // i18n is always sl — exposed for future flexibility
    const changeLocale = (newLocale: string) => {
        ;(i18n.global.locale as any).value = newLocale
    }

    return {
        JWT, loaderActive, userData,
        getJWT, isLoggedIn, isLoaderActive, isMobile,
        setLogin, setLogout, startLoading, stopLoading, changeLocale,
    }
})
